'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002493 from "./presto.types$$anon$93.js";
import * as $j_presto$002etypes$0024$002dIp$002dPayload$0024 from "./presto.types$-Ip-Payload$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Rule$$anon$92(outer) {
  this.c9E = null;
  this.c9w = null;
  this.c9x = false;
  this.c9F = null;
  this.c9G = false;
  this.c9J = null;
  this.c9C = null;
  this.c9D = false;
  this.c9y = null;
  this.c9z = false;
  this.c9A = null;
  this.c9B = false;
  this.c9H = false;
  this.c9I = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.c9E = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c9J = "IpPayload";
}
export { $c_Lpresto_types$Rule$$anon$92 as $c_Lpresto_types$Rule$$anon$92 };
$p = $c_Lpresto_types$Rule$$anon$92.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Rule$$anon$92;
/** @constructor */
function $h_Lpresto_types$Rule$$anon$92() {
}
export { $h_Lpresto_types$Rule$$anon$92 as $h_Lpresto_types$Rule$$anon$92 };
$h_Lpresto_types$Rule$$anon$92.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.c9E;
});
$p.M = (function() {
  if ((!this.c9x)) {
    this.c9w = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c9x = true;
  }
  return this.c9w;
});
$p.O = (function() {
  if ((!this.c9G)) {
    this.c9F = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c9G = true;
  }
  return this.c9F;
});
$p.E = (function() {
  return this.c9J;
});
$p.t = (function() {
  if ((!this.c9D)) {
    this.c9C = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("ip", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c9D = true;
  }
  return this.c9C;
});
$p.N = (function() {
  if ((!this.c9z)) {
    this.c9y = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().Sy(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a8, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c9z = true;
  }
  return this.c9y;
});
$p.Q = (function() {
  if ((!this.c9B)) {
    this.c9A = new $j_presto$002etypes$0024$0024anon$002493.$c_Lpresto_types$$anon$93();
    this.c9B = true;
  }
  return this.c9A;
});
$p.v = (function() {
  if ((!this.c9I)) {
    this.c9H = false;
    this.c9I = true;
  }
  return this.c9H;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee101) => ((p) => \u03b4scrutinee101.cFY(p)))($j_presto$002etypes$0024$002dIp$002dPayload$0024.$m_Lpresto_types$IpPayload$())));
});
var $d_Lpresto_types$Rule$$anon$92 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Rule$$anon$92, "presto.types$Rule$$anon$92", ({
  a1A: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$Rule$$anon$92 as $d_Lpresto_types$Rule$$anon$92 };
//# sourceMappingURL=presto.types$-Rule$$anon$92.js.map
